export const companyKeys = {
  all: ['companies'] as const,

  lists: () => [...companyKeys.all, 'list'] as const,
  list: (all?: boolean) => [...companyKeys.lists(), all ? 'all' : 'filtered'] as const,

  details: () => [...companyKeys.all, 'detail'] as const,
  detail: (id: string) => [...companyKeys.details(), id] as const,
}
